// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n  /* Add styles for the common layout */\n.app-layout[data-v-40d62f2b] {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n.content[data-v-40d62f2b] {\n    flex: 1; /* Allow content to expand and fill available space */\n    padding: 20px; /* Add padding as needed */\n}\n  \n  /* Add more styles for the layout as needed */\n  ", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
